/* * @Author: Wei Guojun * @Date: 2021-04-12 16:50:59 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-11-25 13:58:31 */

<template>
  <div>
    <div class="gobind" v-if="$store.state.bindKdy == 99 || $store.state.bindKdy == 4">
      <i class="el-icon-warning" style="color:#F56C6C;font-size:14px" ></i> 
      <span style="padding:0 10px;color:#F56C6C">您还未添加电子面单账号，无法完成正常下单，打印面单等操作 </span>
      <el-button type="warning" size="mini" style="color:black" @click="bindywy">去添加</el-button>
    </div>
    <div class="headerPend">
      <nav>
        <div>
          <div
            class="menu"
            v-for="(item, index) in nav_list"
            :key="index"
            :class="{ active: $store.state.nav_index === index }"
            @click="goPath(index, item.path)"
          >
            <div v-if="index == 2 && $store.state.waitNum">
              <span>{{ item.name }}({{$store.state.waitNum}})</span>
            </div>
            <div v-else-if="index == 3 && $store.state.printedNum">
              <span>{{ item.name }}({{$store.state.printedNum}})</span>
            </div>
            <!-- <div :value="$store.state.orderNum" class="item" v-else-if="index == 4 && $store.state.orderNum">
              <span>{{ item.name }}</span>
            </div> -->
            <span v-else>{{ item.name }}</span>
          </div>
        </div>
      </nav>
      <!-- <div class="right">
        <div>
          <el-button @click="showImport" size="mini" type="primary" plain>批量导入订单</el-button>
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="750px"
        height="240px"
        top="5%"
        :visible.sync="isImport"
        center
      >
        <div slot="title"></div>
        <div class="model">
          <div class="content">
            <div class="c_title">批量导入:</div>
            <div class="tips">
              <span>*</span>每次最多导入<span>{{ limitNum }}</span
              >单，<u>收件人信息</u>和<u>物品类型</u>为必填项<br />
              可直接拖入文件进行智能导入，若解析有误可通过<el-link
                :href="downloadFileUrl"
                :underline="true"
                type="primary"
                >下载标准模板</el-link
              >进行导入<br />
              模板中“<span>*</span>”为必填项
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="upFile">
            <div class="upHeader">
              <span>智能导入</span>可识别不同排版格式的导入文件
            </div>
            <el-upload
              action=""
              ref="excel-upload-input"
              class="upload-demo"
              drag
              accept=".xlsx, .xls"
              :before-upload="beforeUpload"
              :http-request="uploadAction"
            >
              <div class="uploadBox">
                <img src="../assets/images/fileAdd.png" />
              </div>
              <div class="el-upload__text">
                直接将文件<u>拖拽</u>到此区域，或点击<em>添加上传</em>
              </div>
            </el-upload>
          </div>
        </span>
      </el-dialog> -->
    </div>
  </div>
</template>
<script>
import util from "@/util/util";
import { mapGetters } from "vuex";
import home from "@/api/home";
export default {
  name: "layNav",
  data() {
    return {
      nav_list: [
        { name: "寄快递", path: "/home" },
        { name: "代客下单", path: "/customer" },
        { name: "待打印", path: "/waitPrinted", total: 0 },
        { name: "已打印", path: "/printed", total: 0 },
        // { name: "运单", path: "/orders", total: 0 },
      ],
      nav_index: 0,
      pend_total: 0, // 待打包裹数量
      avatar: "/src/assets/images/logo.png",
      name: "",
      isUp: false,
      isImport: false,
      downloadFileUrl: "https://ydgj.ydpei.com/file/downloadExcelForParcel",
      files: "",
      limitNum: 0,
    };
  },
  created() {
    this.limitNum = util.getJsonValues(this.$store.state.commondict, "excelmaxline") || 200;
    this.$store.dispatch("getthreeNum");
  },
  computed: {
    ...mapGetters(["getFrom"]),
  },
  mounted() {
    //数据挂载
    this.nav_active();
  },
  methods: {
    //跳转绑定
    bindywy(){
      this.$router.push({path:'./electronBill'}) 
      this.$store.commit("SET_ROUTE_FROM", "/electronBill");
    },
    //函数声明
    goPath(index, path) {
      // debugger
      if (this.$store.state.nav_index == index) {
        return;
      }
      let query = {
        status: 0,
        start: "",
        end: "",
      };
      this.$store.commit("SET_ORDER_STATUS", query);
      this.nav_index = index;
      this.$store.state.nav_index = index
      if(path == '/home'){
        this.$router.push({ path: '/home' ,query: {id: 1}});
        this.nav_index = 0;
        this.$store.state.nav_index = 0
        this.$store.state.activeMenu = path;
        this.$store.commit("SET_ROUTE_FROM", path);
      }else if(path == '/customer'){
        this.$router.push({ path: '/home' ,query: {id: 2}});
        this.nav_index = 1;
        this.$store.state.nav_index = 1
        this.$store.state.activeMenu = path;
        this.$store.commit("SET_ROUTE_FROM", path);
      }else{
        this.$router.push(path);
      }
      // this.$store.state.nav_index = this.nav_index
      // this.$router.push(path);
    },
    /** 路由标签判断 */
    nav_active() {
      this.nav_index = this.$store.state.nav_index;
      if(this.nav_index == 0){
        this.$store.commit("SET_ROUTE_FROM", '/home');
        this.$store.state.activeMenu = '/home'
      }
      if(this.nav_index == 1){
        this.$store.commit("SET_ROUTE_FROM", '/customer');
        this.$store.state.activeMenu = '/customer'
      }
    },
    /** 上传中 */
    upFileing(e) {
      this.isUp = true;
    },
    beforeUpload(file) {
      this.files = file;
      this.isUp = true;
      let fileSize = file.size / 1024;
      if (fileSize > 500) {
        this.$message.error("您上传的文件大小超过500kb，请调整后重新上传！");
        this.isUp = false;
        this.isImport = false;
        return;
      }
    },
    uploadAction() {
      let formData = new FormData();
      formData.append("account_id", util.getCookie("account_id"));
      formData.append("file", this.files);
      home.upLoadFile(this, formData).then((res) => {
        if (res.success) {
          if (!res.data.ids.length) {
            this.$message.error(
              "您上传的文件数据为空，请填写数据并保存文件后在试？"
            );
            return;
          }
          localStorage.setItem("IMP_PREVIEW", res.data.ids); // 将数组存入本地缓存
          const wrongNum = res.data.wrong_num;
          const correctNum = res.data.right_num;
          this.$store.state.sheetNum = [wrongNum, correctNum];
          if (wrongNum == 0) {
            this.$store.state.seetIndex = 1;
          }
          this.$message.success("上传成功!");
          this.$store.commit("SET_ROUTE_FROM", "/sheet");
          this.isImport = false;
          this.$router.push({ path: "/sheet" });
        } else {
          this.$message.error("上传失败!");
        }
      });
    },
    showImport() {
      this.$store.commit("SET_ROUTE_FROM", "/sheet");
      this.$router.push({ path: "/sheet" });
    },
  },
};
</script>
<style>
.el-badge__content.is-fixed{
  top: 16px;
  right: 0px;
}
</style>
<style lang="stylus" scoped>
.gobind{
 background-color: rgba(255,228,181,0.5);
 border: 1px solid #fabe00;
 border-radius: 4px;
 margin:10px 0 ;
 padding:4px 0 4px 20px;
 font-size: 12px;
 text-align: center;
}

.headerPend {
  height: 41px;
  font-size: 16px;
  background: #f5f5f5;
  border-radius: 3px;
  font-weight: bold;

  nav {
    float: left;
    color: #737373;

    .header-title {
      float: left;
      height: 50px;
      line-height: 50px;
      margin-left: 20px;
      position: relative;

      span {
        cursor: pointer;
      }

      .edit {
        cursor: auto;
        font-weight: normal;
      }
    }

    .menu {
      float: left;
     height: 41px;
    line-height: 41px;
      margin-left: 20px;
      cursor: pointer;
      position: relative;
      margin-right: 20px;

      &::after {
        position: absolute;
        background: #ffffff;
        content: '';
        left: 50%;
        bottom: 0;
        height: 2px;
        width: 0;
      }
    }

    .active {
      transition: all 0.3s;
      color: #1C8BF6;
      position: relative;

      &::after {
        transition: all 0.3s;
        background: #1C8BF6;
        width: 100%;
        left: 0;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;
    float: right;
    line-height: 38px;
    padding-right: 40px;

    >div {
      margin-left: 20px;
    }
  }

  .upFile {
    position: relative;
    cursor: pointer;
    display: inline-block;
    .upHeader{
      line-height 50px
      height: 50px;
      font-size: 14px;
      text-align left;
      text-indent 10px;
      background: #409EFF;
      color: #fff;
      font-weight:normal;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
      span{
        font-size 16px
        padding-right 10px
      }
    }
    .upload-demo /deep/ .el-upload-dragger{
      width:588px;
    }
    .upload-demo /deep/ .el-upload-list{
      display none;
    }
    .uploadBox{
      width: 60px;
      height: 60px;
      display: flex;
      border: 2px dashed #d9d9d9;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 30px auto;
    }

    .file {
      cursor: pointer;
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
      opacity: 0;
      z-index: 9;
    }
  }

  .model {
    padding: 0 40px;
    font-weight: normal;

    .title {
      color: #212121;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }

    .content {
      text-align: left;
      line-height 30px;
      font-size 14px
      letter-spacing :2px
      .c_title{
        font-size:16px
      }
    }

    .dowbload {
      padding: 15px 0;

      a {
        border: 1px solid #1C8BF6;
        padding: 6px 15px;
        border-radius: 4px;
      }
    }

    span {
      color: #FF0000;
    }
  }

  /deep/ .el-dialog__body {
    padding: 10px 40px;
  }
}
</style>
